module.exports = "https://www.gc-pro.gnp.com.mx/d312736f657bb89b586238784c2b6ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/guia-ayuda-pago.png
// module id = 8114
// module chunks = 0